import * as React from 'react';
import { styled } from '@mui/material/styles';
import Checkbox from '@mui/material/Checkbox';

const BpIcon = styled('span')({
  borderRadius: 8,
  width: 24,
  height: 24,
  backgroundColor: '#eaeaea',
  'input:hover ~ &': {
    backgroundColor: '#eaeaea',
  },
  'input:disabled ~ &': {
    boxShadow: 'none',
    background: 'rgba(206,217,224,.5)',
  },
});

const BpCheckedIcon = styled(BpIcon)({
  backgroundColor: '#a60c00',
  backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute',
    width: '4px',
    height: '9px',
    left: '40%',
    bottom: 'calc(50% - 5px)',
    transform: 'translateX(-50%)', // Center the element horizontally
    border: 'solid #fff',
    borderWidth: '0 2px 2px 0',
    transform: 'rotate(45deg)',
  },
  'input:hover ~ &': {
    backgroundColor: '#a60c00',
  },
});

// Inspired by blueprintjs
function BpCheckbox(props) {
  return (
    <Checkbox
      disableRipple
      color="default"
      checkedIcon={<BpCheckedIcon />}
      icon={<BpIcon />}
      inputProps={{ 'aria-label': 'Checkbox demo' }}
      {...props} // Spread other props to Checkbox
    />
  );
}

export default function CustomCheckbox({ option, checked, onChange }) {
  return (
    <div className="checkbox__item">
      <BpCheckbox checked={checked} onChange={onChange} />
      <span>{option}</span>
    </div>
  );
}
